import { render, staticRenderFns } from "./TopicMgt.vue?vue&type=template&id=7e85ec08&scoped=true&"
import script from "./TopicMgt.vue?vue&type=script&lang=js&"
export * from "./TopicMgt.vue?vue&type=script&lang=js&"
import style0 from "./TopicMgt.vue?vue&type=style&index=0&id=7e85ec08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85ec08",
  null
  
)

export default component.exports